import { api } from "../api";
export const benefitsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getBenefits: build.query({
            query: (args) => {
                const baseUrl = args.isPreview
                    ? `benefit-service/api/v1/widget/preview/benefits`
                    : `benefit-service/api/v1/widget/user/benefits`;
                return {
                    url: baseUrl,
                    headers: {
                        "X-Loyalty-Language": (args === null || args === void 0 ? void 0 : args.locale).split('-')[0],
                        Authorization: `Bearer ${args === null || args === void 0 ? void 0 : args.jwt}`,
                    },
                };
            },
            forceRefetch: () => true,
        }),
        redeem: build.mutation({
            query: (args) => ({
                url: `benefit-service/api/v1/widget/user/benefit/${args.benefitCode}/redeem`,
                headers: {
                    "X-Loyalty-Language": (args.locale).split('-')[0],
                    Authorization: `Bearer ${args.jwt}`,
                },
                method: "POST",
            }),
        }),
    }),
});
//# sourceMappingURL=benefits.api.js.map